import React from "react";
import log from "cslog";
import Element from "../ElementStaticView";
// import { mobile, tablet } from "../../../../data/bp";
import { mobile, tablet, parseStyle, isHidden } from "../../../juntion";
import ContainerWrapper from "./wrappers/ContainerWrapper";

function Box({ id, db, dydb, device, gs, ctx, index }) {
    const data = db[id];

    const ps = parseStyle(data, gs, null);

    const minHeight = "50px";

    if (isHidden(ps.classes, device)) {
        return null;
    }

    return (
        <ContainerWrapper
            id={id}
            data={data}
            dydb={dydb}
            gs={gs}
            device={device}
            index={index}
        >
            <div
                style={{
                    width: "100%",
                }}
            >
                {data.childs.map((item) => {
                    return (
                        <Element
                            key={item}
                            id={item}
                            db={db}
                            dydb={dydb}
                            gs={gs}
                            device={device}
                            ctx={ctx}
                        />
                    );
                })}
            </div>
        </ContainerWrapper>
    );
}

export default Box;
